(function () {

    'use strict';

    angular
        .module('auditMandateModule')
        .controller('AuditMandateEditController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'historyCtxtService', 'auditMandateService', 'auditMandate', 'lookupAttributes', 'controls'];

    function Controller($scope, topBarService, historyCtxtService, auditMandateService, auditMandate, lookupAttributes, controls) {

        topBarService.setTitleAndIcon('Edit Audit Mandate', 'fa fa-road');
        $scope.auditMandate = auditMandate;
        $scope.controls = controls;
        $scope.lookupAttributes = lookupAttributes;

        // Edit Observation
        $scope.editObservation = function (item) {
            historyCtxtService.goToState('observation.edit',
                { ObservationID: item.ObservationID },
                'auditMandate'
            );
        };

        // Go To Governance Process
        $scope.onGovProcessClick = function () {
            $state.go('auditMandateEdit', { AuditMandateID: observation.GovernanceProcess.GovernanceProcessID }, {});
        };

        // Add Observation
        $scope.addObservation = function () {
            historyCtxtService.goToState('observation.addForAuditMandate',
                { AuditMandateID: auditMandate.GovernanceProcessID },
                'auditMandate'
            );
        };

        // Control
        $scope.goToControl = function (control) {
            historyCtxtService.goToState('control',
                { ControlID: control.ControlID },
                'auditMandate'); //maybe missing auditMandate
        };

        // Add a new related control
        $scope.addControl = function (control) {

            auditMandateService
                .addControlToAuditMandate($scope.auditMandate.AuditMandateID, control.ControlID)
                                    .then(function (controls) {
                                        //$scope.auditMandate.Controls = controls;
                                        $scope.controls = controls;
                                    });
        };

        // Unlink a control
        $scope.unlinkControl = function (control) {

            auditMandateService
                .removeControlFromAuditMandate($scope.auditMandate.AuditMandateID, control.ControlID)
                                    .then(function () {
                                        //$scope.auditMandate.Controls = _.reject($scope.risk.Controls, { ControlID: control.ControlID });
                                        $scope.controls = _.reject($scope.controls, { ControlID: control.ControlID });
                                    });
        }

    }
})();